// External Dependencies:
import React from 'react'

class Badge extends React.Component {
	render() {
		const { badgeId, isMini, isMedium, withText, isUnattained } = this.props
		let className = `badge badge-${badgeId}`
		let number, icon, text1

		if ( isMini ) {
			className += ' is-mini'
		}

		if ( isMedium ) {
			className += ' is-medium'
		}

		switch ( badgeId ) {
			case 'account':
				text1 = `You've created a Faith FM account! Welcome!`
				break

			case 'listen_3_hours':
				text1 = isUnattained
					? `To attain this badge, listen to Faith FM online for a total of 3 hours.`
					: `You've listened to Faith FM online for a total of 3 hours! That's&nbsp;great!`
				number = '3'
				break

			case 'listen_25_hours':
				text1 = isUnattained
					? `To attain this badge, listen to Faith FM online for a total of 25 hours.`
					: `You've listened to Faith FM online for a total of 25 hours! That's&nbsp;superb!`
				number = '25'
				break

			case 'listen_100_hours':
				text1 = isUnattained
					? `To attain this badge, listen to Faith FM online for a total of 100 hours.`
					: `You've listened to Faith FM online for a total of 100 hours! That's&nbsp;amazing!`
				number = '100'
				break

			case 'record_votd':
				text1 = isUnattained
					? `To attain this badge, record your first Verse of the Day.`
					: `You've recorded your first Verse of the Day!`
				break

			case 'donate':
				text1 = isUnattained
					? `To attain this badge, make your first donation.`
					: `You've made your first donation!`
				break

			case 'donate_recurring':
				text1 = isUnattained
					? `To attain this badge, become a monthly supporter.`
					: `You're a monthly supporter!`
				break

			case 'unlimited_access':
				text1 = `You have unlimited access.`
				break
		}

		if ( isUnattained ) {
			className += ' is-unattained'
		}

		return (
			<div className={ className }>
				<div className="-badge-inner">
					<img src={ `${siteData.images_url}badges/${badgeId}.svg` } alt="" />

					{ number &&
						<div className="-number">{ number }</div>
					}

					{ icon }
				</div>

				{ withText &&
					<div className="-text">
						<p dangerouslySetInnerHTML={ { __html: text1 } } />
					</div>
				}
			</div>
		)
	}
}

export default Badge
